export default {
	//apiHost: import.meta.env.VITE_API_HOST || 'https://client.lifelonglevelup.com',
	apiHost: 'https://'+window.location.host,
        adminHost: 'https://'+window.location.host+'/admin'

}


